/** @type {Styles} */

export const styles = {
  loading: {
    height: 48,
    width: 'auto',
    animation: 'spin 2s infinite',
    animationTimingFunction: 'cubic-bezier(.74,0,.16,1)',

    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
  },
}
